export default __webpack_public_path__ + "static/media/collapsed.b571f86e.svg";